const components = {
    "designs": {
        "pack_templates": {
            "index": () => import('./../pages/admin/designs/templates/index'),
            "form": () => import('./../pages/admin/designs/templates/pack-form'),
            "view": () => import('./../pages/admin/designs/templates/view')
        },
        "page_templates": {
            "index": () => import('./../pages/admin/designs/templates/pages/index'),
            "form": () => import('./../pages/admin/designs/templates/pages/page-form')
        },
        "block_templates": {
            "index": () => import('./../pages/admin/designs/templates/blocks/index'),
            "form": () => import('./../pages/admin/designs/templates/blocks/block-form')
        },
        'categories': () => import('./../pages/admin/designs/categories'),
        'platforms': () => import('./../pages/admin/designs/platforms'),
        'types': () => import('./../pages/admin/designs/types'),
        'groups': () => import('./../pages/admin/designs/groups'),
        'tags': () => import('./../pages/admin/designs/tags'),
        'dependencies': () => import('./../pages/admin/designs/dependencies'),
    },

    "client": {
        "licenseDetail": () => import('./../pages/client/license-details/index'),
        "manageAPIs": () => import('./../pages/client/manage-api/index'),
        "ourCloud": () => import('./../pages/client/our-cloud/index'),
        "paymentHistory": () => import('./../pages/client/payment-history/index'),
        "profile": () => import('./../pages/client/profile/index'),
        "shareFile": () => import('./../pages/client/share-file/index'),
        "workspace": () => import('./../pages/client/workspace/index')
    },

    "connected_accounts": {
        "payments": () => import('./../pages/payments/index'),
        "redeemCode": () => import('./../pages/profile/redeem-code/index'),
        "paymentProfile": () => import('./../pages/payment-profile/index'),
    },

    "refund_requests": {
        "index": () => import('./../pages/refund-requests/index'),
    },

    "promotions": {
        "benefits": () => import('./../pages/promotions/benefits'),
        "freeLicense": () => import('./../pages/promotions/free-license'),
    },

    "settings":{
        "downloadItems": () => import('./../pages/admin/download-items/index'),
        "refunds": () => import('./../pages/admin/refunds/index'),
        "schedules": () => import('./../pages/admin/schedules/index'),
        "redemptions": () => import('./../pages/admin/redemptions/index'),
        "promotionalBenefits": () => import('./../pages/admin/promotional/benefits/index'),
    }
};

export default components;
